/**
 * 환경 변수에 따라 WebSocket URL을 생성하는 유틸리티 함수
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * WebSocket URL을 생성합니다.
 * - 로컬 개발 환경: ws://localhost:PORT 경로 직접 사용
 * - 프로덕션 환경: 프록시 경로 사용 (/mercury-stock/..., /mercury-crypto/...)
 * 
 * @param service - 서비스 타입 ('stock' | 'crypto')
 * @param path - WebSocket 경로 (예: 'rt-ranking-fluctuation-daily', 'rt-upbit-ticker')
 * @param port - 로컬 개발 환경에서 사용할 포트 (기본값: stock=8081, crypto=8082)
 * @returns WebSocket URL
 */
export const getWebSocketUrl = (
  service: 'stock' | 'crypto',
  path: string,
  port?: number
): string => {
  if (isDevelopment) {
    // 로컬 개발 환경: 직접 포트 사용
    const defaultPort = service === 'stock' ? 8081 : 8082;
    const wsPort = port || defaultPort;
    return `ws://localhost:${wsPort}/${path}`;
  } else {
    // 프로덕션 환경: 프록시 경로 사용
    const servicePrefix = service === 'stock' ? 'mercury-stock' : 'mercury-crypto';
    return `/${servicePrefix}/${path}`;
  }
};

